import React from 'react';
import styled from 'styled-components';

import { ReactComponent as FileImageIcon } from './assets/file-image.svg';
import { ReactComponent as FileLinkIcon } from './assets/file-link.svg';
import { ReactComponent as FileOtherIcon } from './assets/file-other.svg';
import { ReactComponent as FilePDFIcon } from './assets/file-pdf.svg';
import { ReactComponent as FileSlidesIcon } from './assets/file-slides.svg';
import { ReactComponent as FileSpreadsheetIcon } from './assets/file-spreadsheet.svg';
import { ReactComponent as FileTextIcon } from './assets/file-text.svg';
import { ReactComponent as FileVideoIcon } from './assets/file-video.svg';
import { ReactComponent as StripeIcon } from './assets/stripe-logo.svg';

const Base = styled.span`
	height: ${props => props.size}px;
	width: ${props => props.size}px;
`;

const getSize = props => {
	const { small, large, size } = props;
	if (small) return 12;
	if (large) return 24;
	if (size) return size;
	return 16;
};

const asIcon =
	source =>
	({ small, large, size, ...props }) =>
		<Base className="icon" as={source} size={getSize({ small, large, size })} {...props} />;

export const FileImage = asIcon(FileImageIcon);
export const FileLink = asIcon(FileLinkIcon);
export const FileOther = asIcon(FileOtherIcon);
export const FilePDF = asIcon(FilePDFIcon);
export const FileSlides = asIcon(FileSlidesIcon);
export const FileSpreadsheet = asIcon(FileSpreadsheetIcon);
export const FileText = asIcon(FileTextIcon);
export const FileVideo = asIcon(FileVideoIcon);
export const Stripe = asIcon(StripeIcon);
